import { CasoMailbox } from './caso.model';
import { CasoPreocupante } from './casopreocupante.model';

export class AnonymousMailbox {

    public Caso: CasoMailbox;
    
    public CasoPreocupante: CasoPreocupante;

    public EsCasoEmpleado: boolean;
}